import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { NS } from '../../../i18n/constants/keys';
import { translateView } from '../../../i18n/helpers/translateView';
import { setCurrentView } from '../../../utils/redux_store/features/ViewReducer';
import { RootState } from '../../../utils/redux_store/store';
import { View } from '../../../utils/types/assessment_types';

const ViewOption: React.FC = () => {
  const { t } = useTranslation(NS.navbarMenus);
  const dispatch = useDispatch();
  const accessibleViews = useSelector(
    (state: RootState) => state.view.accessibleViews,
  );
  const currentView = useSelector((state: RootState) => state.view.currentView);
  const handleViewChange = (view: View) => {
    dispatch(setCurrentView(view));
  };

  return (
    <Box
      sx={(theme) => ({
        display: 'grid',
        gridTemplateColumns: `repeat(${Math.max(accessibleViews.length, 1)}, 1fr)`,
        gap: 0.5,
        p: 0.5,
        borderRadius: 2,
        bgcolor: alpha(theme.palette.text.primary, 0.05),
      })}
    >
      {accessibleViews.map((view: View) => {
        const isSelected = currentView === view;
        return (
          <Button
            key={view}
            size="small"
            onClick={() => handleViewChange(view)}
            disabled={!accessibleViews.includes(view)}
            sx={(theme) => ({
              textTransform: 'none',
              fontSize: '0.75rem',
              fontWeight: 800,
              py: 0.75,
              borderRadius: 1.5,
              transition: 'all 0.2s ease-in-out',
              bgcolor: isSelected ? 'background.paper' : 'transparent',
              color: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
              boxShadow: isSelected ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
              '&:hover': {
                bgcolor: isSelected ? 'background.paper' : alpha(theme.palette.text.primary, 0.08),
                color: isSelected ? theme.palette.primary.main : theme.palette.text.primary,
              },
            })}
          >
            {translateView(t, view)}
          </Button>
        );
      })}
    </Box>
  );
};

export default ViewOption;
